import molin_1 from '../../assets/images/tra/molin_1.webp';
import '../../styles/common.css'
import { useNavigate, NavLink } from 'react-router-dom';

export default function MainStreet() {
  const navigate = useNavigate();
  return (
    <div className="relative">
      <div className="absolute w-auto top-[3vw] right-[3vw]  z-[9999]">
        <nav className="flex justify-end space-x-[5.7vw] ml-auto">
          <NavLink
            to="/#molin-section"
            className="text-[1vw] tracking-wider font-normal transition-transform hover:scale-110  text-[#000]"
          >
            <div className="flex flex-col text-center w-[15vw] rounded-[3vw] bg-[rgba(255,255,255,0.3)] hover:bg-[rgba(255,255,255,0.7)]  backdrop-blur-sm">
              <span className=' mt-[0.5vw]'>返回天籁瓷鉴</span>
              <span className=" mb-[0.5vw] text-[1vw] transform translate-x-[0.4vw] -translate-y-[0.2vw]">
                Back to Tianlai.China
              </span>
            </div>
          </NavLink>
        </nav>
      </div>
      <img src={molin_1} alt="Hero background" className="w-full h-auto" />
      <div className="top-[3vw] w-auto absolute left-[5%] transform -translate-x-1/2">
        <div className="flex flex-row items-left gap-[1.5vw]">
          <span className="text-[1.4vw] vertical-text-ml text-[#000000] font-bold">项元汴的鉴藏故事</span>
        </div>
      </div>
      <div className="top-[3.5vw] absolute left-[8%] w-[48%] z-[9999] text-justify">
        <div className="flex flex-col">
          <span className="text-[#000000] text-[0.7vw]">明代是精品书画鉴藏从内府官藏向民间私人购藏转变的时期
          </span>
          <span className="text-[#000000] text-[0.7vw]">项元汴为鉴藏中心的江南地区商人群体是这一时期的活跃角色，明代中晚期鉴藏风习出现了一些鲜明的时代特色：江南地区商人群体的鉴藏链，以及他们参与的其他商业文化活动进行古玩收集。江浙一带的古玩艺术市场已初具规模，不仅出现了固定的店肆、古董铺，还出现了带有集市性质的设摊交易
          </span>
          <span className="text-[#000000] text-[1vw] mt-[1vw]">The Story of Xiang Yuanbian's Art Collection and Appraisal
          </span>
          <span className="text-[#000000] text-[0.7vw]">
            The Ming dynasty marked a pivotal era in the evolution of premium calligraphy and painting curation, transitioning from imperial collections to private civilian acquisitions. Xiang Yuanbian, a leading figure in the Jiangnan region’s commercial art circles, played a central role in this transformation. During the mid-to-late Ming period, art collecting exhibited distinct characteristics: Jiangnan’s merchant groups formed an art curation network, actively participating in antique trading and broader cultural-commercial activities. The antique art market in the Jiangnan and Zhejiang regions had already matured, featuring fixed shops and antique stores, as well as market-style stall transactions, reflecting a sophisticated commercial infrastructure for art circulation. </span>
        </div>
      </div>
      <div className='absolute bottom-[44%] left-[2%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">码头街区</span>
          <span className="text-[#000000] text-[0.8vw]">Marina District</span>
        </div>
        <div className="absolute top-[-1.8vw] left-[4.2vw]">
          <button className="rounded-full breathe-m bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate('/marinadistrict')}>
          </button>
        </div>
      </div>
      <div className='absolute bottom-[15%] left-[25%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">酒楼藏宝阁</span>
          <span className="text-[#000000] text-[0.8vw]">Restaurant Treasure Pavilion</span>
        </div>
        <div className="absolute top-[-2vw] left-[4.2vw]">
          <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate("/restauranttreasurepavilion")}>
          </button>
        </div>
      </div>
      <div className='absolute bottom-[38%] left-[28%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">设摊交易</span>
          <span className="text-[#000000] text-[0.8vw]">Stall Trading</span>
        </div>
        <div className="absolute top-[-1.8vw] left-[4.2vw]">
          <button className="rounded-full breathe-m bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate("/stalltrading")}>
          </button>
        </div>
      </div>
      <div className='absolute bottom-[48%] left-[35%] h-[6vw] w-[12vw] transition-transform duration-300 hover:scale-110'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">项元汴友人(安国)</span>
          <span className="text-[#000000] text-[0.8vw]">A friend of Xiang Yuanbian (An Guo)</span>
        </div>
        <div className="absolute top-[-1.8vw] left-[4.2vw]">
          <button className="rounded-full breathe-m bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate("/friendofxiang")} >
          </button>
        </div>
      </div>
      <div className='absolute bottom-[48%] left-[48%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">街区2</span>
          <span className="text-[#000000] text-[0.8vw]">Street Block 2</span>
        </div>
        <div className="absolute top-[-1.8vw] left-[4.2vw] cursor-pointer">
          <button className="rounded-full breathe-m bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate("/streetblock2")} >
          </button>
        </div>
      </div>
      <div className='absolute bottom-[28%] left-[60%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">项家 天籁阁</span>
          <span className="text-[#000000] text-[0.8vw]">Xiang's Tianlai Pavilion</span>
        </div>
        <div className="absolute top-[-2vw] left-[4.2vw] cursor-pointer">
          <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate("/substreet")} >
          </button>
        </div>
      </div>
      <div className='absolute bottom-[8%] left-[78%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">商人郭五游</span>
          <span className="text-[#000000] text-[0.8vw]">Merchant Guo Wuyou</span>
        </div>
        <div className="absolute top-[-2vw] left-[4.2vw] cursor-pointer">
          <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate("/merchant")} >
          </button>
        </div>
      </div>
      <div className='absolute bottom-[38%] left-[84%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">街区1</span>
          <span className="text-[#000000] text-[0.8vw]">Street Block 1</span>
        </div>
        <div className="absolute top-[-1.8vw] left-[4.2vw] cursor-pointer">
          <button className="rounded-full breathe-m bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate("/streetblock1")} >
          </button>
        </div>
      </div>
      <div className='absolute bottom-[25%] left-[90%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">项氏鉴古堂</span>
          <span className="text-[#000000] text-[0.8vw]">Xiang's Appraisal Hall</span>
        </div>
        <div className="absolute top-[-1.8vw] left-[4.2vw] cursor-pointer">
          <button className="rounded-full breathe-m bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate("/appraisalhall")} >
          </button>
        </div>
      </div>
    </div>
  )
}

